import Main from './main.js';
import Header from './header.js';
import CustomDescription from './customDescription.js';
import Services from './services.js';
import Highlights from './highlights.js';
import Credentials from './credentials.js';
import WorkHistory from './workHistory.js';
import Footer from './footer.js';
import ProfileNotAvailable from './profileNotAvailable.js';
import metaData from './metaData.js';
import Review from './review.js';


export default {
  Main,
  Header,
  CustomDescription,
  Services,
  Highlights,
  Credentials,
  WorkHistory,
  Review,
  Footer,
  ProfileNotAvailable,
  metaData,
};
